<template>
  <Transition name="fade">
    <component
      :is="animationComponent"
      v-if="isAnimationRunning && !isReducedMotion && animationComponent"
      v-show="isAnimationShowing"
    />
  </Transition>
</template>
<script setup>
import { useSeasonalTheme } from '@/v2/composables/useSeasonalTheme.js';
import { SEASONAL_ANIMATIONS } from '@/v2/components/animations/seasonalAnimationRegistry.js';
import { computed } from 'vue';
import { useReducedMotion } from '@/v2/composables/useReducedMotion.js';

const { getAnimationKey, isAnimationRunning, isAnimationShowing } =
  useSeasonalTheme();
const { isReducedMotion } = useReducedMotion();

const animationComponent = computed(() => {
  const key = getAnimationKey();
  return SEASONAL_ANIMATIONS[key] ?? null;
});
</script>
<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 1000ms ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
